import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Badge } from "primereact/badge";
import { useState } from "react";
import { SubscriptionSummaryDTO } from "../../models/UserSubscriptions/UserSubscriptions-model";

type Props = {
  sub: SubscriptionSummaryDTO;
  onPauseResume: (sub: SubscriptionSummaryDTO) => void;
  onEdit?: (sub: SubscriptionSummaryDTO) => void;
};

const SubscriptionCard = ({ sub, onPauseResume, onEdit }: Props) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Card
      className="mb-3 h-full flex flex-column"
      style={{
        boxShadow: isHovered
          ? "0 8px 20px rgba(144, 238, 144, 0.7)"
          : "0 4px 12px rgba(144, 238, 144, 0.5)",
        borderRadius: "8px",
        border: "1px solid #e2f5e2",
        transform: isHovered ? "scale(1.03)" : "scale(1)",
        transition: "all 0.3s ease",
        zIndex: isHovered ? 10 : 1,
        height: "100%"
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="flex flex-column flex-grow-1 p-2">
        {/* Status badge */}
        <Badge
          value={sub.isActive ? "Active" : "Inactive"}
          severity={sub.isActive ? "success" : "danger"}
          className="absolute top-0 right-0 m-1"
          style={{ fontSize: '0.8rem' }}
        />

        <div className="text-xs text-500 mb-1">SUBSCRIPTION</div>
        <div className="font-bold mb-2 text-lg">#{sub.id}</div>

        {/* Subscription details */}
        <div className="flex flex-column gap-2 mb-3">
          <div className="flex align-items-center justify-content-between">
            <div className="text-600 text-sm">Frequency</div>
            <div className="font-semibold">{sub.frequencyValue} days</div>
          </div>
          <div className="flex align-items-center justify-content-between">
            <div className="text-600 text-sm">Address ID</div>
            <div className="font-semibold">{sub.deliveryAddressId}</div>
          </div>
        </div>

        {/* Action buttons */}
        <div className="flex justify-content-around mt-auto gap-1">
          <Button
            icon={sub.isActive ? "pi pi-pause" : "pi pi-play"}
            label={sub.isActive ? "Pause" : "Resume"}
            onClick={() => onPauseResume(sub)}
            className={sub.isActive ? "p-button-warning text-xs" : "p-button-success text-xs"}
            style={{ minWidth: "80px", padding: "0.3rem" }}
          />
          {onEdit && (
            <Button
              icon="pi pi-pencil"
              label="Edit"
              onClick={() => onEdit(sub)}
              className="p-button-outlined text-xs"
              style={{ minWidth: "60px", padding: "0.3rem" }}
            />
          )}
        </div>
      </div>
    </Card>
  );
};

export default SubscriptionCard;
